import React from 'react';
import styles from './ReportRSOPage.module.scss';
import RcoConteiner from './components/ui/RcoConteiner/RcoConteiner';
import { useNavigationBlocker } from '../../../../hooks/useNavigationBlocker';
import { Icon, Modal } from 'antd';
import { links } from '../../constants/links';
import { useDispatch, useSelector } from 'react-redux';
import { setClearAllState } from './store/actions/rsoImportActions';

export const selectIsNavigationBlocked = (state) => {
  const loadingFileRSO = state.rsoImportStore.loadingFileRSO;
  const getFileRso = state.rsoImportStore.getFileRso;
  const file = state.rsoImportStore.file;

  return Boolean(!loadingFileRSO && !getFileRso && file);
};

const ReportRSOPage = () => {
  const dispatch = useDispatch();

  const isBlocked = useSelector(selectIsNavigationBlocked);

  useNavigationBlocker(isBlocked, ({ location, unblock, history }) => {
    const path = location.pathname;

    if (
      path.startsWith(links.rootWithCompany) &&
      path.endsWith(links.reportRSO)
    ) {
      unblock();
      history.push(location);
      return;
    }

    Modal.confirm({
      title: 'Вы уверены, что хотите покинуть страницу "Отчет в РСО" ?',
      content: 'Введенные вами данные будут потеряны.',
      okText: 'Да',
      cancelText: 'Нет',
      icon: (
        <Icon
          type="question-circle"
          style={{ color: '#0995ED' }}
        />
      ),
      className: styles.customConfirmModalRso,
      onOk: () => {
        unblock();
        history.push(location);
        dispatch(setClearAllState());
      },
      onCancel: () => {},
    });
  });

  return (
    <div className={styles.conteiner}>
      <RcoConteiner />
    </div>
  );
};

export default ReportRSOPage;
